export const VALID_TYPES = ["any", "object", "string", "number", "bigint", "boolean", "string[]", "number[]", "bigint[]", "boolean[]"];
export const SCALAR_TYPES = ['undefined', 'boolean', 'number', 'bigint', 'string'];
export function isValidQSType(value) {
    return VALID_TYPES.includes(value);
}
